import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { SearchResultCardComponent } from '../search-result-card/search-result-card.component';
import { ISearchItem } from '../search.model';
import { SearchService } from '../search.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrl: './search-results.component.scss',
  imports: [CommonModule, SearchResultCardComponent]
})
export class SearchResultsComponent {
  constructor(private searchService: SearchService) {}

  get searchResultItems$() {
    return this.searchService.searchResultItems$;
  }

  get searchForm() {
    return this.searchService.searchForm;
  }

  get isInvalidSearchTermLength() {
    return this.searchService.isInvalidSearchTermLength;
  }

  get isLoadingResults() {
    return this.searchService.isLoadingResults;
  }

  hasResultItems(resultItems: ISearchItem[]) {
    return (
      resultItems.length > 0 &&
      resultItems.some((item) => item.isEligible !== false)
    );
  }
}
